module.exports = __webpack_public_path__ + "static/media/101774636_681656359070168_7381719777208696832_n.d549d3f2.jpg";